// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep pre {
  font-family: Roboto, "Helvetica Neue", sans-serif;
  font-size: 1rem;
}

svg:not(:root) {
  position: relative;
}

.strike {
  top: 80%;
  display: block;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}

.strike > span {
  position: relative;
  display: inline-block;
}

.strike > span:before,
.strike > span:after {
  position: absolute;
  top: 78%;
  width: 250px;
  height: 1px;
  content: "";
  background: #2b3761;
}

.strike > span:before {
  right: 70%;
  margin-right: 55px;
}

.strike > span:after {
  left: 70%;
  margin-left: 55px;
}

@media screen and (min-width: 0) and (max-width: 780px) {
  #my-content-1 {
    display: none;
  }
}
@media screen and (min-width: 781px) {
  #my-content-2 {
    display: none;
  }
  .right-content {
    top: 130px;
  }
}
svg {
  min-height: 120px;
}

.fix-min-height {
  min-height: 350px;
}

.pos-bottom {
  position: absolute;
  bottom: 20px;
  width: 100%;
}

.center-pad {
  padding-top: 60px;
  padding-bottom: 70px;
}

.text-label {
  margin-top: 6px;
}

.remove-input-border {
  background-image: none;
  font-size: 16px;
  font-weight: 400;
}

@media screen and (min-width: 0) and (max-width: 952px) {
  .center-pad {
    padding-top: 30px;
  }
}
.no-border {
  border: none;
}

.no-margin-top-bottom {
  margin-top: 0;
  margin-bottom: 0;
}

.textarea {
  white-space: pre-wrap;
}

.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  transition: box-shadow 150ms ease;
  border-radius: 4px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form.checkout {
  margin: 2rem auto;
  padding: 3px;
  text-align: center;
  color: #525252;
  border: 2px solid #eee;
  background-color: #ebf1f7;
  font-family: monospace;
  font-size: 1.1rem;
}

form.checkout button {
  width: 100%;
  padding: 0.5rem 1rem;
  color: white;
  border: none;
  background: rgb(26, 127, 203);
  font-size: 16px;
  font-weight: 500;
}

form.checkout button:active {
  background: rgb(23, 82, 137);
}

label {
  color: #8898aa;
  font-size: 13.5px;
}

#form-field {
  padding: 3px;
  background-color: white !important;
}

#card-info {
  min-width: 400px;
}

mat-error {
  display: flex;
  align-items: center;
  justify-content: center;
}

#card-errors {
  padding: 3px;
  font-size: 13px;
}

.image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
  margin-top: 76px;
}

.cards {
  position: relative;
  overflow: hidden;
  height: 55px;
  margin-left: 10px;
  padding: 0 10px;
}

.cards > div {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.cards > div > img {
  margin-right: 20px;
}

#information-message {
  padding: 10px 0;
  color: #67656b;
  font-size: 0.71rem;
}

#submit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 600;
}

#submit-button:hover {
  background-color: rgb(73, 153, 215);
}

#info-icon {
  margin-left: 5px;
}

.cards img {
  width: 55px;
}

@media screen and (max-width: 650px) {
  ::ng-deep .cdk-overlay-pane {
    min-width: 95vw !important;
    max-width: 100% !important;
  }
  ::ng-deep mat-dialog-container {
    padding-right: 4px !important;
    padding-left: 4px !important;
  }
  form {
    width: 95%;
  }
  form.checkout {
    padding: 1rem 5px !important;
  }
  .image {
    flex-direction: column;
  }
  .cards {
    margin-top: 10px;
  }
  .cards img {
    width: 15%;
  }
  #card-info {
    min-width: 100%;
  }
}
.payment-form {
  animation-name: payment-form;
  animation-duration: 0.4s;
  animation-timing-function: linear;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

@keyframes payment-form {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.payment-methods {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  transition: 0.2s;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.payment-methods:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.card-details {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 19px;
}

.card-name {
  color: #303238;
  font-size: 19px;
  font-weight: 600;
  font-style: italic;
}

@media only screen and (max-width: 800px) {
  .payment-methods {
    flex-direction: column;
  }
}
div a {
  color: #518dc9;
}

.cursorPointer {
  cursor: pointer;
}

.termspoint {
  padding-top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/new-order/new-order3/new-order3.component.scss"],"names":[],"mappings":"AAAA;EACC,iDAAA;EACA,eAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,QAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACD;;AAEA;EACC,kBAAA;EACA,qBAAA;AACD;;AAEA;;EAEC,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AACD;;AAEA;EACC,UAAA;EACA,kBAAA;AACD;;AAEA;EACC,SAAA;EACA,iBAAA;AACD;;AAEA;EACC;IACC,aAAA;EACA;AACF;AAEA;EACC;IACC,aAAA;EAAA;EAED;IACC,UAAA;EAAA;AACF;AAGA;EACC,iBAAA;AADD;;AAIA;EACC,iBAAA;AADD;;AAIA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AADD;;AAIA;EACC,iBAAA;EACA,oBAAA;AADD;;AAIA;EACC,eAAA;AADD;;AAIA;EACC,sBAAA;EACA,eAAA;EACA,gBAAA;AADD;;AAIA;EACC;IACC,iBAAA;EADA;AACF;AAIA;EACC,YAAA;AAFD;;AAKA;EACC,aAAA;EACA,gBAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,sBAAA;EACA,YAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;AAFD;;AAKA;EACC,+BAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,oCAAA;AAFD;;AAMA;EAEC,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AAJD;;AAOA;EACC,WAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EAEA,gBAAA;AALD;;AAQA;EACC,4BAAA;AALD;;AAQA;EACC,cAAA;EACA,iBAAA;AALD;;AAQA;EACC,YAAA;EACA,kCAAA;AALD;;AAQA;EACC,gBAAA;AALD;;AAQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AALD;;AAQA;EACC,YAAA;EACA,eAAA;AALD;;AAQA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AALD;;AAQA;EACC,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AALD;;AAQA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALD;;AAQA;EACC,kBAAA;AALD;;AAQA;EACC,eAAA;EACA,cAAA;EACA,kBAAA;AALD;;AAQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AALD;;AAQA;EACC,mCAAA;AALD;;AAQA;EACC,gBAAA;AALD;;AAQA;EACC,WAAA;AALD;;AAQA;EACC;IACC,0BAAA;IACA,0BAAA;EALA;EAQD;IACC,6BAAA;IACA,4BAAA;EANA;EASD;IACC,UAAA;EAPA;EAUD;IACC,4BAAA;EARA;EAWD;IACC,sBAAA;EATA;EAYD;IACC,gBAAA;EAVA;EAaD;IACC,UAAA;EAXA;EAcD;IACC,eAAA;EAZA;AACF;AAgBA;EACC,4BAAA;EACA,wBAAA;EACA,iCAAA;EACA,qBAAA;EAEA,6BAAA;AAfD;;AAkBA;EACC;IACC,qBAAA;IACA,UAAA;EAfA;EAkBD;IACC,mBAAA;IACA,UAAA;EAhBA;AACF;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;AAjBD;;AAoBA;EACC,qCAAA;AAjBD;;AAoBA;EACC,2DAAA;EACA,eAAA;AAjBD;;AAoBA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAjBD;;AAoBA;EACC;IACC,sBAAA;EAjBA;AACF;AAoBA;EACC,cAAA;AAlBD;;AAqBA;EACC,eAAA;AAlBD;;AAqBA;EACC,gBAAA;AAlBD","sourcesContent":["::ng-deep pre {\n\tfont-family: Roboto, 'Helvetica Neue', sans-serif;\n\tfont-size: 1rem;\n}\n\nsvg:not(:root) {\n\tposition: relative;\n}\n\n.strike {\n\ttop: 80%;\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-align: center;\n\twhite-space: nowrap;\n}\n\n.strike > span {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.strike > span:before,\n.strike > span:after {\n\tposition: absolute;\n\ttop: 78%;\n\twidth: 250px;\n\theight: 1px;\n\tcontent: '';\n\tbackground: #2b3761;\n}\n\n.strike > span:before {\n\tright: 70%;\n\tmargin-right: 55px;\n}\n\n.strike > span:after {\n\tleft: 70%;\n\tmargin-left: 55px;\n}\n\n@media screen and (min-width: 0) and (max-width: 780px) {\n\t#my-content-1 {\n\t\tdisplay: none;\n\t}\n}\n\n@media screen and (min-width: 781px) {\n\t#my-content-2 {\n\t\tdisplay: none;\n\t}\n\t.right-content {\n\t\ttop: 130px;\n\t}\n}\n\nsvg {\n\tmin-height: 120px;\n}\n\n.fix-min-height {\n\tmin-height: 350px;\n}\n\n.pos-bottom {\n\tposition: absolute;\n\tbottom: 20px;\n\twidth: 100%;\n}\n\n.center-pad {\n\tpadding-top: 60px;\n\tpadding-bottom: 70px;\n}\n\n.text-label {\n\tmargin-top: 6px;\n}\n\n.remove-input-border {\n\tbackground-image: none;\n\tfont-size: 16px;\n\tfont-weight: 400;\n}\n\n@media screen and (min-width: 0) and (max-width: 952px) {\n\t.center-pad {\n\t\tpadding-top: 30px;\n\t}\n}\n\n.no-border {\n\tborder: none;\n}\n\n.no-margin-top-bottom {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n\n.textarea {\n\twhite-space: pre-wrap;\n}\n\n.StripeElement {\n\tbox-sizing: border-box;\n\theight: 40px;\n\tpadding: 10px 12px;\n\t-webkit-transition: box-shadow 150ms ease;\n\ttransition: box-shadow 150ms ease;\n\tborder-radius: 4px;\n}\n\n.StripeElement--focus {\n\tbox-shadow: 0 1px 3px 0 #cfd7df;\n}\n\n.StripeElement--invalid {\n\tborder-color: #fa755a;\n}\n\n.StripeElement--webkit-autofill {\n\tbackground-color: #fefde5 !important;\n}\n\n// for stripe form\nform.checkout {\n\t//max-width: 500px;\n\tmargin: 2rem auto;\n\tpadding: 3px;\n\ttext-align: center;\n\tcolor: #525252;\n\tborder: 2px solid #eee;\n\tbackground-color: #ebf1f7;\n\tfont-family: monospace;\n\tfont-size: 1.1rem;\n}\n\nform.checkout button {\n\twidth: 100%;\n\tpadding: 0.5rem 1rem;\n\tcolor: white;\n\tborder: none;\n\tbackground: rgb(26, 127, 203);\n\tfont-size: 16px;\n\t//margin-top: 1rem;\n\tfont-weight: 500;\n}\n\nform.checkout button:active {\n\tbackground: rgb(23, 82, 137);\n}\n\nlabel {\n\tcolor: #8898aa;\n\tfont-size: 13.5px;\n}\n\n#form-field {\n\tpadding: 3px;\n\tbackground-color: white !important;\n}\n\n#card-info {\n\tmin-width: 400px;\n}\n\nmat-error {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n#card-errors {\n\tpadding: 3px;\n\tfont-size: 13px;\n}\n\n.image {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: auto;\n\tmargin-top: 76px;\n}\n\n.cards {\n\tposition: relative;\n\toverflow: hidden;\n\theight: 55px;\n\tmargin-left: 10px;\n\tpadding: 0 10px;\n}\n\n.cards > div {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n}\n\n.cards > div > img {\n\tmargin-right: 20px;\n}\n\n#information-message {\n\tpadding: 10px 0;\n\tcolor: #67656b;\n\tfont-size: 0.71rem;\n}\n\n#submit-button {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\ttransition: 0.2s;\n\tfont-weight: 600;\n}\n\n#submit-button:hover {\n\tbackground-color: rgb(73, 153, 215);\n}\n\n#info-icon {\n\tmargin-left: 5px;\n}\n\n.cards img {\n\twidth: 55px;\n}\n\n@media screen and (max-width: 650px) {\n\t::ng-deep .cdk-overlay-pane {\n\t\tmin-width: 95vw !important;\n\t\tmax-width: 100% !important;\n\t}\n\n\t::ng-deep mat-dialog-container {\n\t\tpadding-right: 4px !important;\n\t\tpadding-left: 4px !important;\n\t}\n\n\tform {\n\t\twidth: 95%;\n\t}\n\n\tform.checkout {\n\t\tpadding: 1rem 5px !important;\n\t}\n\n\t.image {\n\t\tflex-direction: column;\n\t}\n\n\t.cards {\n\t\tmargin-top: 10px;\n\t}\n\n\t.cards img {\n\t\twidth: 15%;\n\t}\n\n\t#card-info {\n\t\tmin-width: 100%;\n\t}\n}\n\n// payment form animation\n.payment-form {\n\tanimation-name: payment-form;\n\tanimation-duration: 0.4s;\n\tanimation-timing-function: linear;\n\tanimation-delay: 0.3s;\n\n\tanimation-fill-mode: forwards;\n}\n\n@keyframes payment-form {\n\t0% {\n\t\ttransform: scale(0.8);\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n}\n\n.payment-methods {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 15px;\n\ttransition: 0.2s;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n}\n\n.payment-methods:hover {\n\tbackground-color: rgba(0, 0, 0, 0.07);\n}\n\n.card-details {\n\tfont-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n\tfont-size: 19px;\n}\n\n.card-name {\n\tcolor: #303238;\n\tfont-size: 19px;\n\tfont-weight: 600;\n\tfont-style: italic;\n}\n\n@media only screen and (max-width: 800px) {\n\t.payment-methods {\n\t\tflex-direction: column;\n\t}\n}\n\ndiv a {\n\tcolor: #518dc9;\n}\n\n.cursorPointer{\n\tcursor: pointer;\n}\n\n.termspoint{\n\tpadding-top: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
